import { observer } from 'mobx-react-lite';
import React from 'react';
import { useParams } from 'react-router';

import { Input } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { StoresContext } from '@feathr/extender/state';

import BillableEdit from './BillableEdit';

function BillableEditPage() {
  const { Billables } = React.useContext(StoresContext);
  const { billingId } = useParams<{ billingId: string }>();
  const billable = Billables.get(billingId);

  const title = (
    <Input
      attribute={['description']}
      design={'naked'}
      model={billable}
      placeholder={'Enter a simple description...'}
      type={'text'}
    />
  );

  return (
    <Page pageTitle={`Edit ${billable.get('description')}`} title={title}>
      <BillableEdit billable={billable} />
    </Page>
  );
}

export default observer(BillableEditPage);
